<template>
  <BaseModal
    width="440px"
    height="auto"
    @close="$emit('close')"
  >
    <template #header>{{ title }}</template>
    <template #body>
      <img
        class="py-10 w-full cursor-pointer"
        alt="notice_img"
        :src="noticeImgSrc"
      />
    </template>
    <template #footer>
      <div class="flex justify-between">
        <button
          @click="$emit('noMore')"
          class="w-1/2 outline"
        >
          다시 보지 않기
        </button>
        <button
          @click="$emit('close')"
          class="w-1/2 ml-2"
        >
          닫기
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { defineComponent, toRefs, ref, onMounted } from 'vue';
import BaseModal from '@/components/baseComponent/BaseModal.vue';
import router from '@/router';

export default defineComponent({
  name: 'ModalPopup',
  emits: ['close', 'noMore'],
  components: { BaseModal },
  props: {
    title: { type: String, required: true },
    src: { type: String, required: true },
  },
  setup: (props) => {
    const moveToNotice = () => {
      router.push('/help/notice');
    };

    const noticeImgSrc = ref<string>('');
    const convertImgSrc = () => {
      if (!props.src) return;
      const imageUrl = import.meta.glob('@/assets/image/popup/**/*', { eager: true });
      const matchedImage = Object.keys(imageUrl).find((path) => path.endsWith(props.src));
      noticeImgSrc.value = matchedImage ? (imageUrl[matchedImage] as { default: string }).default : '';
    };

    onMounted(() => {
      convertImgSrc();
    });

    return { moveToNotice, noticeImgSrc, convertImgSrc, ...toRefs(props) };
  },
});
</script>

<style lang="scss" scoped></style>
